import { api } from '@/api';
import { AxiosResponse } from 'axios';

// 파일 크기 포맷팅
export const formatFileSize = (bytes: number) => {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

// 파일 확장자 추출
export const getFileExtension = (filename: string) => filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);

// 파일 타입 체크
export const isImageFile = (filename: string) => {
	const ext = getFileExtension(filename).toLowerCase();
	return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext);
};

export const downloadPdf = async (pk: string | number) => {
	const response: AxiosResponse = await api.get(
		`/v1/front/getReceipt`,
		{
			pay_info_pk: pk,
		},
		{
			responseType: 'blob',
		}
	);

	const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
	const link = document.createElement('a');
	link.href = downloadUrl;
	link.setAttribute('download', '타이키파트너스 영수증.pdf');
	document.body.appendChild(link);
	link.click();
	link.remove();
};

export const downloadFile = async (url: string, pk: string) => {
	const fileExtension = url.split('.').pop()?.toLowerCase();
	const isViewable = ['pdf'].includes(fileExtension || '');

	if (isViewable) {
		window.open(url, '_blank');
	} else {
		window.open(`${import.meta.env.VITE_APP_BASE_URL}/v1/common/fileDownload?file_pk=${pk}`);
	}
};
